import React from 'react';

/**
 * Minimal interface for props of custom link components.
 * The custom link component should not have any styles
 * as all button styles should be handled by Clickable.
 */
export interface CustomLinkComponentProps {
    href: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
    className?: string;
    disabled?: boolean;
    focusable?: boolean;
    children?: React.ReactNode;
    target?: string;
    rel?: string;
    accessibleWhenDisabled?: boolean;
}

export type CustomLinkComponent = React.ForwardRefExoticComponent<
    React.PropsWithoutRef<CustomLinkComponentProps> & React.RefAttributes<HTMLAnchorElement>
>;
